import { VStack } from '@cad-arc';
import { UnitHistoryItemsGroup } from '@mark43/cad-api';
import { UnitHistoryItemsCard } from './unit-history-items-card';

export function UnitHistoryResults({
    unitHistoryItemsGroups,
    scrollElementRef,
}: {
    unitHistoryItemsGroups: UnitHistoryItemsGroup[];
    scrollElementRef: React.RefObject<HTMLDivElement>;
}): React.ReactElement {
    return (
        <VStack spacing="16px" ref={scrollElementRef}>
            {unitHistoryItemsGroups.map((unitHistoryItemsGroup, idx) => (
                <UnitHistoryItemsCard
                    key={idx}
                    unitHistoryItemsGroup={unitHistoryItemsGroup}
                    index={idx}
                />
            ))}
        </VStack>
    );
}
